export default function CateringIcon() {
  return <i className="fa-solid fa-bell-concierge"></i>
}